<template>
    <div class="w-100">
        <div class="step-title primary--text" style="margin-bottom: 10px;">
            <div>{{ title }}</div>
            <c-site-tzb-rating
                v-if    =" rating"
                v-model = "rating"
                :style  = "'padding-right: ' + this.paddingRight + 'px'"
            />
        </div>
    </div>
</template>

<script>

import CSiteTzbRating from "@/modules/msd/unit/components/dialog/CSiteTzbRating";

export default {
    name: "MsdTzbTitle",

    components: {
        CSiteTzbRating
    },

    props: {
        title: {
            required: true,
            type: String
        },

        rating: {
            required: false,
        },

        paddingRight: {
            required: false,
            type: Number,
            default: function () {
                return 0;
            }
        }
    },

    computed: {
        tzbRating () {
            return 6 - this.rating.id;
        }
    }
}
</script>

<style scoped>

</style>